import { createContext, useContext } from 'react';

// Only the telephone queue provides this context. Shared dialogs elsewhere keep
// their existing save/close behaviour. A save includes its success callback.
export const CallSaveContext = createContext({
  run: operation => operation(), busy: false, suspended: false,
});
export const useCallSave = () => useContext(CallSaveContext).run;
